<wl-content-section [id]="id()" [theme]="theme()">
  <div class="row">
    <div class="col-lg-8 mb-8 mb-lg-0">
      <sc-placeholder name="funnel-column-dynamic" [rendering]="rendering()" />
    </div>
    <aside class="col-lg-4">
      <sc-placeholder
        class="d-grid gap-5"
        name="aside-column-dynamic"
        [rendering]="rendering()"
      />
    </aside>
  </div>
</wl-content-section>
